<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="60px">
          <el-form-item label="店铺">
            <el-select v-model="searchForm.storeCode" filterable placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in useObjectList"
                :label="item.name"
                :key="item.code"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="型号">
            <el-autocomplete
              v-model="searchForm.bigModel"
              :fetch-suggestions="querySkuList"
              @blur="getCategoryMappingBigModel(true)"
              @focus="onSkuCodeFocus(2)"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="类别">
            <el-autocomplete
              v-model="searchForm.category"
              :fetch-suggestions="querySkuList"
              @blur="getCategoryMappingBigModel(true)"
              @focus="onSkuCodeFocus(0)"
            ></el-autocomplete>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="addDialogShow">新增</el-button>
        <el-button type="primary" size="mini" @click="importExcel">导入</el-button>
      </template>
      <el-table
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        ref="table"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :height="maxTableHeight"
        :data="tableData.records"
        border
        style="width: 100%"
      >
        <el-table-column fixed prop="storeName" label="店铺" align="center" :show-overflow-tooltip="true" />
        <el-table-column fixed prop="category" label="类别" align="center" :show-overflow-tooltip="true" />
        <el-table-column prop="bigModel" label="大型号" align="center" :show-overflow-tooltip="true" />
        <el-table-column prop="createdDate" label="创建时间" align="center" :show-overflow-tooltip="true" />
        <el-table-column prop="createdBy" label="创建人" align="center" :show-overflow-tooltip="true" />
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="edit(scope.row)">编辑</el-link>
            <el-link type="danger" :underline="false" @click="del(scope.row)" style="margin-left: 10px">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            :total="paginationOpt.total"
            layout="total, sizes, prev, pager, next, jumper"
            background
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 新增/编辑弹框 -->
    <edit-dialog :visible.sync="addDialogVisible" :row="editRow" @success="init" v-if="addDialogVisible" />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import EditDialog from './edit-dialog.vue';

export default {
  name: 'StoreMainPushModel',
  mixins: [pagePathMixin, tableMixin],
  components: {
    EditDialog,
  },
  data() {
    return {
      loading: false,
      addDialogVisible: false,
      searchForm: {
        storeCode: '',
        bigModel: '',
        category: '',
      },
      editRow: {},
      tableData: {
        records: [],
      },
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      // 搜索相关
      useObjectList: [],
      optionsn: [],
      inputData: [],
      inputIndex: 9,
    };
  },
  mounted() {
    this.init();
    this.salesGetStore();
    this.getOptionsn();
  },
  methods: {
    handleSearch() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    resetForm() {
      this.searchForm = {
        storeCode: '',
        bigModel: '',
        category: '',
      };
      this.getOptionsn();
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      this.loading = true;
      let formData = {
        exportTag: true,
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          ...this.searchForm,
        },
      };
      this.$q.intelligentRecom
        .getMainModelPageList({ data: formData })
        .then((res) => {
          if (res.data.records.length && res.code == 200) {
            this.tableData = res.data;
            this.paginationOpt['total'] = res.data.total;
          } else {
            this.paginationOpt['pageNum'] = 1;
            this.paginationOpt['total'] = 0;
            this.tableData = { records: [] };
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    addDialogShow() {
      this.editRow = {};
      this.addDialogVisible = true;
    },
    importExcel() {
      this.openSubPage({
        path: '/importMainBigModel',
        query: {
          fileName: '店铺主推型号导入.xlsx',
          appCode: 'ec-pc-api',
        },
      });
    },
    edit(row) {
      this.editRow = row;
      this.addDialogVisible = true;
    },
    async del(row) {
      let status = await this.$confirm('是否确认删除该条数据？');
      if (status !== 'confirm') return;
      this.$q.intelligentRecom.deleteMainModelConfig({ fragment: [row.dataId] }).then((res) => {
        if (res.code == 200) {
          this.$message.success('删除成功');
          this.init();
        }
      });
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    // 搜索相关方法
    salesGetStore() {
      this.$q.intelligentRecom.getMainModelStore({}).then((res) => {
        this.useObjectList = res.data;
      });
    },
    onSkuCodeFocus(index) {
      this.inputIndex = index;
      if (index == 0) {
        this.inputData = this.optionsn.category;
      } else if (index == 1) {
        this.inputData = this.optionsn.style;
      } else {
        this.inputData = this.optionsn.bigModel;
      }
    },
    queryStringFales(queryString, cb) {
      let data = {
        categoryName: this.searchForm.category,
        smallModel: this.searchForm.smallModel,
        bigModel: this.searchForm.bigModel,
      };
      this.$q.intelligentRecom
        .optionsn({ data: data })
        .then((res) => {
          this.optionsn = res.data;
          if (this.inputIndex == 0) {
            this.inputData = this.optionsn.category;
          } else if (this.inputIndex == 2) {
            this.inputData = this.optionsn.bigModel;
          }
          let data = this.inputData;
          if (!data || !data.allOptions) {
            cb([]);
            return;
          }
          let results = queryString
            ? data.allOptions
                .map((v) => v.criteriaContent)
                .filter((item) => item.toLowerCase().includes(queryString.toLowerCase()))
            : data.allOptions
            ? data.allOptions.filter((v) => !v.useFlag).map((v) => v.criteriaContent)
            : [];
          if (!results || !results.length) {
            cb([]);
            return;
          }
          results = results.map((item) => ({
            ...item,
            value: item,
          }));
          cb(results);
        })
        .finally((_) => {});
    },
    queryStringTrue(queryString, cb) {
      let data = this.inputData;
      if (!data || !data.allOptions) {
        cb([]);
        return;
      }
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) => item.toLowerCase().includes(queryString.toLowerCase()))
        : data.allOptions
        ? data.allOptions.filter((v) => !v.useFlag).map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      if (this.inputIndex == 0) {
        this.optionsn.bigModel = [];
        this.getCategoryMappingBigModel();
      } else if (this.inputIndex == 2 && queryString && queryString.length > 2) {
        this.optionsn.category = [];
        this.getCategoryMappingBigModel();
      }
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      cb(results);
    },
    querySkuList(queryString, cb) {
      if (queryString) {
        this.queryStringTrue(queryString, cb);
      } else {
        this.queryStringFales(queryString, cb);
      }
    },
    getOptionsn(data) {
      this.$q.intelligentRecom.optionsn({ data: data || {} }).then((res) => {
        this.$nextTick((_) => {
          this.optionsn = res.data;
        });
      });
    },
    getCategoryMappingBigModel(type) {
      setTimeout(
        (_) => {
          let data = {
            categoryName: this.searchForm.category,
            bigModel: this.searchForm.bigModel,
          };
          this.getOptionsn(data);
        },
        type ? 200 : 0
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right

.search-box
  >>> .el-select, >>> .el-input, >>> .el-autocomplete
    width 200px !important
</style>